import 'bootstrap/js/dist/collapse';

function setupNavbarToggler()
{
    let nav = document.querySelector('.navbar-mobile');
    let toggler = document.querySelector('.navbar-toggler');

    if (!nav || !toggler) {
        return;
    }

    toggler.addEventListener('click', () => {
        let isOpen = nav.classList.contains('open');
        let navbarHeight = document.querySelector('.site-header-container').clientHeight;

        if (!isOpen) {
            nav.classList.add('open');
            nav.style.height = (window.innerHeight - navbarHeight) + 'px';
            document.body.classList.add('hide-overflow');
        } else {
            nav.classList.remove('open');
            document.body.classList.remove('hide-overflow');
        }
    });
}

function lazyLoadBackgoundImages()
{
    const lazyloadImages = document.querySelectorAll(".lazy-bg");
    const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const image = entry.target;
                image.classList.remove("lazy-bg");
                imageObserver.unobserve(image);
            }
        });
    });

    lazyloadImages.forEach(image => {
        imageObserver.observe(image);
    });

}

document.addEventListener('DOMContentLoaded', () => {
    setupNavbarToggler();
    lazyLoadBackgoundImages();
});
